module.exports = __webpack_public_path__ + "static/media/site_scan.07a410ef.png";